export default {
  iosUrl: "itms-services://?action=download-manifest&url=https://asset.ncaicai.tech/app/tcly/tcly.plist",
  androidUrl: "http://asset.ncaicai.tech/app/tcly/tcly.apk",
  apiDomain: "https://www.xiayue.online",
  sharePrefix: "#tcly#",
};
